// extracted by mini-css-extract-plugin
export default {"more-results":"_5DPdYU6d","more-results__link":"_5D3ahsJp"};